import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { resetUser } from "State/Auth/AuthReducer";

// Signing out wipes the persisted state, so the way back is a full reload of this very URL: the app boots signed
// out, the route wrapper stores it as the place to return to and sends the person to sign in, exactly like a cold visit.
export const useSignOutAndReturn = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  return () => {
    const returnUrl = location.pathname + location.search;
    dispatch(
      resetUser({ onAfterReset: () => window.location.assign(returnUrl) }),
    );
  };
};
